import React, {useEffect, useState} from 'react';
import Menu from '../../Menu';
import Profile from '../../Sidebar/Author/Profile';
import Copyright from '../../Sidebar/Copyright';
import styles from './Nav.module.scss';
import {useSiteMetadata} from '../../../hooks';

const Nav = () => {
  const {author, copyright} = useSiteMetadata();
  // set scroll direction state
  const [scrollDir, setScrollDir] = useState('');
  const [menuState, setMenuState] = useState(false);

  useEffect(() => {
    const threshold = 76;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (scrollY < 0) return
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }

      setScrollDir(scrollY <= threshold ? '' : scrollY > lastScrollY ? 'down' : 'up');
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollDir]);

  const toggleMenuState = (e) => {
    e.preventDefault();
    // update menu state
    setMenuState(!menuState);
    // disabled body scroll
    // if (!menuState) {
    //   document.querySelector('body').style.height = '100%'
    //   document.querySelector('body').style.overflow = 'hidden'
    // } else {
    //   document.querySelector('body').style.height = 'auto'
    //   document.querySelector('body').style.overflow = 'visible'
    // }
  }

  return (
    <div
      className={
        `${styles['nav']} ${scrollDir === 'up'
            ? styles['is-scroll']
            : ''
        } ${scrollDir === 'down'
            ? styles['hide']
            : ''
        } ${menuState ? 'menu-active' : ''}
    `}
    >
      <nav className={`${styles['nav-content']} nav`}>
        <Profile author={author} size={36} align={true}/>

        <button
          className={`button-burger ${menuState ? 'active' : ''}`}
          aria-label="Show menu"
          onClick={toggleMenuState}
        >
        <span className="button-burger__container-bars">
          <span className="button-burger__bar"/>
          <span className="button-burger__bar"/>
          <span className="button-burger__bar"/>
        </span>
        </button>
      </nav>

      <Menu />
      <Copyright copyright={copyright} isMenu={true} />
    </div>
  );
};

export default Nav;
